module.exports = __webpack_public_path__ + "img/Russia2.4fe4a753.png";